
<div class="content-wrap">
    <div id="content" class="content admin_tool_content">
        <div class="">
            <h1 class="page-title pl0">Add Telecommute survey data<span class="fw-semi-bold"></span></h1>
            <section class="widget overflow-auto">
                <header>
                    <h5 class="mb10">Enter the below details to add telecommute data for a property. Please use this <a href="../../assets/pdf/Telecommute data.pdf" download>guide</a> to learn how to use this tool.</h5>
                </header>
                <div class="widget-body">
                    <form class="form-horizontal" role="form">
                        <fieldset [ngClass]="loader ? 'not-active' : ''">
                            <div class="form-group">
                                <label for="normal-field" class="col-sm-4 control-label">Property ID (starting with 4) or LEED ID (starting with 1 or 8)</label>
                                <div class="col-sm-4">
                                    <input [(ngModel)]="leed_id" type="text" id="normal-field" class="form-control"
                                        placeholder="Property ID or LEED ID" [ngModelOptions]="{standalone: true}">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-4 control-label" for="prepended-input">Survey Submitted Date</label>
                                <div class="col-sm-4">
                                    <input id="commute_date" [(ngModel)]="commute_date" class="col-sm-7 form-control"
                                        [ngInit]="enableFdatePicker()" name="commute_date">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-4 control-label" for="prepended-input">Commuters</label>
                                <div class="col-sm-4">
                                    <input [(ngModel)]="teleworkers" type="text" id="normal-field" class="form-control"
                                        placeholder="Number of telecommuters" [ngModelOptions]="{standalone: true}">
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-4 control-label" for="prepended-input"></label>
                                <div class="col-sm-4">
                                    <div [ngClass]="loader ? 'not-active' : ''">
                                        <ul style="padding-left: 0px;" class="wizard display-block pull-left mr10">
                                            <li class="next list_style_none align-right">
                                                <button (click)="addData()" class="btn btn-default">Submit</button> 
                                            </li>
                                        </ul>
                                        <div *ngIf="loader" class="dataInputLoaderSpinner pull-left"></div>
                                    </div>
                                </div>
                            </div>

                        </fieldset>
                    </form>
                </div>
            </section>
        </div>
    </div>
</div>